module.exports = __webpack_public_path__ + "static/media/icon-pdf-black.4b576c6e.svg";